import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { Check, XClose } from '@untitled-ui/icons-react';
import { Controller, FieldValues, useFormContext } from 'react-hook-form';

type CheckListProps = {
  question: string;
  itemKey: string;
  title: string;
  documentType: string;
  buttonsLocked: boolean;
  disabled?: boolean;
  clarificationReplacement?: boolean;
};

const CheckList = ({ question, itemKey, title, documentType, buttonsLocked, disabled, clarificationReplacement }: CheckListProps) => {
  const { control } = useFormContext<FieldValues>();
  const isInteractionBlocked = buttonsLocked || !!disabled;

  return (
    <Controller
      name={`checklist.${documentType}.${itemKey}`}
      control={control}
      render={({ field }) => {
        const isValid = field.value === 'valid';
        const isErr = field.value === 'error';

        return (
          <Flex mb={5} opacity={disabled ? 0.4 : 1}>
            <Flex alignItems="flex-start">
              <Flex mt={1}>
                <Button
                  borderRadius={4}
                  size="sm"
                  color="white"
                  bgColor={isValid && !clarificationReplacement ? 'green.500' : 'gray.500'}
                  mr={2}
                  onClick={isValid || isInteractionBlocked ? undefined : () => field.onChange('valid')}
                  pointerEvents={isValid || isInteractionBlocked ? 'none' : 'auto'}
                  cursor={isValid || isInteractionBlocked ? 'default' : 'pointer'}
                  _hover={isInteractionBlocked ? {} : { bg: 'green.400' }}
                >
                  <Icon as={Check} fontSize="20" />
                </Button>
                <Button
                  borderRadius={4}
                  size="sm"
                  color="white"
                  bgColor={isErr ? 'red.500' : 'gray.500'}
                  onClick={isErr || isInteractionBlocked ? undefined : () => field.onChange('error')}
                  pointerEvents={isErr || isInteractionBlocked ? 'none' : 'auto'}
                  cursor={isErr || isInteractionBlocked ? 'default' : 'pointer'}
                  _hover={isInteractionBlocked ? {} : { bg: 'red.500' }}
                >
                  <Icon as={XClose} fontSize="20" />
                </Button>
              </Flex>
              <Flex direction="column" ml={5} justifyContent="center">
                <Text fontSize={14} fontWeight={600} whiteSpace="wrap" m={0} p={0}>
                  {title}
                </Text>
                <Text fontSize={14} whiteSpace="wrap" m={0} p={0}>
                  {question}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        );
      }}
    />
  );
};

export default CheckList;
